module.exports = ".file-preview{\r\n    height: 250px; \r\n    width: \"100%\"; \r\n    border: 2px solid #ccc; \r\n    display: -ms-flexbox; \r\n    display: flex; \r\n    -ms-flex-align: center; \r\n        align-items: center; \r\n    -ms-flex-pack: center; \r\n        justify-content: center;\r\n    background-color: #f0f0f0;\r\n}\r\n.duplicate-row{\r\n    color: red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/faq/import-faq/import-faq.component.css
// module id = 969
// module chunks = 1